<article class="">
    <header class="">
        <div class="">
            <ul class="list-inline d-flex justify-content-between mb-0">
                <li class="list-inline-item">
                    <h1 class="">Terminal Handling Charges</h1>
                </li>
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info mx-1" (click)="printPage()">
                        <i class="ti ti-printer"></i>
                    </button>
                    <button aria-label="Copy link" class="btn btn-icon btn-light-info" (click)="copyFullPageText()">
                        <i class="ti ti-copy"></i>
                    </button>
                </li>
            </ul>
            <!-- <ul class="list-inline d-flex justify-content-start" >
                <li class="list-inline-item">
                    <button class="btn btn-icon btn-light-info me-1">
                        <i class="ti ti-pencil"></i>
                    </button>Last updated on January 26, 2024 at 4:25 PM
                </li>
            </ul> -->
        </div>
    </header>
    <div class="">
        <div class="card-body p-2">
            <p class="mb-4 mt-1">Terminal Handling Charges (or THCs) are fees charged by container terminals at the origin
                (OTHC) and
                destination (DTHC) ports for the services that they provide.</p>
            <h2 class="my-4">Xeneta's THC Methodology</h2>
            <p class="my-4">By default, ocean freight rates found in Xeneta included THCs according to the following
                guidelines:</p>
            <div class="table-responsive my-4">
                <table class="table table-striped my-4">
                    <tbody>
                        <tr>
                            <td colspan="9" id="thc-table-to"
                                style="width: 28px; text-align: center; vertical-align: middle;"><strong>To</strong>
                            </td>
                        </tr>
                        <tr>
                            <td id="thc-table-from" rowspan="8"
                                style="width: 38px; text-align: center; vertical-align: middle;"><strong>From</strong>
                            </td>
                            <td style="width: 38px;">&nbsp;</td>
                            <td style="width: 38px;"><strong>Africa</strong></td>
                            <td style="width: 39px;"><strong>Asia</strong></td>
                            <td style="width: 39px;"><strong>Middle East</strong></td>
                            <td style="width: 39px;"><strong>Europe</strong></td>
                            <td style="width: 39px;"><strong>North America</strong></td>
                            <td style="width: 39px;"><strong>South America</strong></td>
                            <td style="width: 39px;"><strong>Oceania</strong></td>
                        </tr>
                        <tr>
                            <td style="width: 38px;"><strong>Africa</strong></td>
                            <td style="width: 38px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">DTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                        </tr>
                        <tr>
                            <td style="width: 38px;"><strong>Asia</strong></td>
                            <td style="width: 38px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">DTHC</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">DTHC</td>
                        </tr>
                        <tr>
                            <td style="width: 38px;"><strong>Middle East</strong></td>
                            <td style="width: 38px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">DTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                        </tr>
                        <tr>
                            <td style="width: 38px;"><strong>Europe</strong></td>
                            <td style="width: 38px;">NONE</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">OTHC DTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                        </tr>
                        <tr>
                            <td style="width: 38px;"><strong>North America</strong></td>
                            <td style="width: 38px;">OTHC</td>
                            <td style="width: 39px;">OTHC DTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC<br>DTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                        </tr>
                        <tr>
                            <td style="width: 38px;"><strong>South America</strong></td>
                            <td style="width: 38px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">DTHC</td>
                            <td style="width: 39px;">NONE</td>
                            <td style="width: 39px;">NONE</td>
                        </tr>
                        <tr>
                            <td style="width: 38px;"><strong>Oceania</strong></td>
                            <td style="width: 38px;">NONE</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">DTHC</td>
                            <td style="width: 39px;">OTHC</td>
                            <td style="width: 39px;">OTHC</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <blockquote class="my-4 p-3 bg-yellow-100 color-block">
                <p class="m-0">Due to specific regulations, Xeneta does not display separate OTHC values for
                    <strong>North
                        American</strong> ports. Instead, THC fees are already included within the rate information you
                    get in our platform.
                </p>
            </blockquote>
            <blockquote class="p-3 bg-gray-200 color-block my-4">To view all the charges that we include in our rates,
                you
                can <a
                    href="https://cdn.elev.io/file/uploads/7rMuoX7QtXJ6psY2MyB2fXmaIgxnxoeXBP57N-qzYow/NpqbI6WlHxXSqK-zTOvUYMNJMYuTBMaDCk8OvF0hGrk/xeneta-surcharge-list--Cs.pdf"
                    rel="noopener noreferrer" target="_blank">download the full list</a> in PDF format (194 Kb).
            </blockquote>
            <h2 class="my-4">Viewing Your Own THCs</h2>
            <p class="my-4">When displaying your uploaded freight rates, Xeneta by default uses its THC methodology
                based on origin
                and destination.</p>
            <p class="my-4">Our methodology may not always match the actual THCs associated with your rates, and as a
                result you may
                notice that the rates within Xeneta are different from what you expect.</p>
            <p class="my-4">If that happens, you can select the <strong>THC - User</strong> option — this will use the
                THCs that came
                with your uploaded rates instead of relying on Xeneta's methodology.</p>
            <p class="my-4">
                <img src="../../../../../assets/img/filters.png" class="my-4" width="100%">
            </p>
            <blockquote class="my-4 p-3 bg-blue-100 color-block">
                <p class="mx-0 my-1">Selecting the <strong>THC - User</strong> option will update the rates shown across
                    all pages in
                    Xeneta where that option is available, including the Market Overview and Performance Overview pages,
                    Price and Spend Benchmarks pages, as well as all exported reports.</p>
            </blockquote>
        </div>
    </div>
    <div class="m-4" hidden>
        <div class=" ">
            <h3 class=" ">Was this article helpful?</h3>
            <div class=" ">
                <button class="btn btn-icon btn-outline-secondary mx-2">
                    <i class="ti ti-thumb-down"></i>
                </button>
                <button class="btn btn-icon btn-outline-secondary">
                    <i class="ti ti-thumb-up"></i>
                </button>
            </div>
        </div>
    </div>
</article>